// removed by extract-text-webpack-plugin
module.exports = {"root":"root_lgCoS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Wrapper/style.css
// module id = 180
// module chunks = 0